// local
import Api from '.';

export function ping() {
    return Api.get('/ping');
}

export function cep(id) {
    return Api.get(`/cep/${id}`);
}

export default { ping, cep };